import { render, staticRenderFns } from "./courseupComing.vue?vue&type=template&id=2805c282&scoped=true"
import script from "./courseupComing.vue?vue&type=script&lang=js"
export * from "./courseupComing.vue?vue&type=script&lang=js"
import style0 from "./courseupComing.vue?vue&type=style&index=0&id=2805c282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805c282",
  null
  
)

export default component.exports